export const StatusCode = {
  Loading: 1,
  Filtering: 2,
  Loaded: 3,
  Error: 4,
};
